mutation createDepositAddress {
    createDepositAddress
}
